<template>
  <div class="ev-page-container">
    <!-- edit absence modal -->
    <modal
      name="edit-absence-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-absence
        :selectedAbsence="selectedAbsence"
        :isEmployeeChangeDisabled="true"
        :isSaveAndProceedButtonVisible="false"
        :statuses="statuses"
        :employees="employees"
        :departments="departments"
        title="Uredi odsustvo"
        @saveAndCloseClicked="editAbsence"
      />
    </modal>

    <!-- add absence modal -->
    <modal
      name="add-absence-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-absence
        :selectedAbsence="selectedAbsence"
        :isSaveAndProceedButtonVisible="false"
        :statuses="statuses"
        :employees="employees"
        :departments="departments"
        title="Dodaj odsustvo"
        @saveAndCloseClicked="addAbsence"
        @saveAndProceedClicked="addAbsenceAndContinue"
      />
    </modal>

    <!-- delete absence modal -->
    <modal
      name="delete-absence-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <div class="ev-delete-modal">
        <delete-item
          message="Da li zaista želite da obrišete odsustvo?"
          title="Obriši odsustvo"
          :selectedItem="selectedAbsence"
          @deleteButtonClicked="deleteAbsence"
        />
      </div>
    </modal>

    <!-- Page Header with inline filter -->
    <div class="page-header-inline">
      <div class="header-left">
        <h1 class="ev-page-title">
          <span class="ev-title-icon">📅</span>
          Odsustva
        </h1>
        <span class="header-subtitle">Administracija odsustva u preduzeću</span>
      </div>
      <div class="header-right">
        <label class="ev-filter-label">Izaberi mjesec</label>
        <date-picker
          v-model="time3"
          @input="monthChosen"
          type="month"
        ></date-picker>
      </div>
    </div>

    <!-- Table Section -->
    <div class="ev-table-section">
      <div class="ev-table-header">
        <h3 class="ev-table-title">
          <span class="ev-table-icon">📋</span>
          Lista odsustva
        </h3>
        <div class="header-actions">
          <a @click="toggleActive" class="toggle-link">{{
            stringOnlyActive
          }}</a>
        </div>
      </div>
      <div class="ev-table-container">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :search-options="{
            enabled: true,
            searchFn: searchFunc,
            placeholder: 'Pretraži...',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'before'">
              <div class="ev-action-buttons" v-if="props.row.isnew === false">
                <!-- edit icon -->
                <button
                  class="ev-action-btn ev-action-btn-edit"
                  @click="editRow(props.row)"
                  title="Uredi"
                >
                  <font-awesome-icon icon="edit" />
                </button>
                <!-- delete icon -->
                <button
                  class="ev-action-btn ev-action-btn-delete"
                  @click="deleteRow(props.row)"
                  title="Obriši"
                >
                  <font-awesome-icon icon="trash-alt" />
                </button>
              </div>
              <!-- add new row button -->
              <button
                class="ev-btn ev-btn-primary ev-btn-sm"
                v-if="props.row.isnew === true"
                @click="addRow(props.row)"
              >
                <font-awesome-icon icon="plus" /> Dodaj
              </button>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import ReportService from "../../services/report.service";
import SpecialReportService from "../../services/specialreport.service";
import EditAbsence from "../parts/EditAbsence.vue";
import DeleteItem from "../parts/DeleteItem.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { VueGoodTable } from "vue-good-table";

import { EmployeeStatusBack } from "../../models/absence.js";

import {
  getReport01TitlePropertyFromStatusId,
  getDepartmentFromEmployeeId,
  getDaysArray,
  // getFromDateOnlyDatePart,
} from "../../_helpers/arrangers.js";

export default {
  name: "Absence",

  components: { VueGoodTable, EditAbsence, DeleteItem, DatePicker },

  data() {
    return {
      showOnlyActive: true,
      stringOnlyActive: "prikaži i neaktivna odsustva",
      statuses: [],
      employees: [],
      departments: [],
      time3: null,
      selectedAbsence: null,
      departmentData: null,
      selectedEmployee: {
        department: {
          name: null,
          id: null,
          shiftId: null,
        },
      },
      columns: [
        {
          label: "r.br.",
          field: "ndx",
          type: "number",
          sortable: false,
        },
        {
          label: "Zaposleni",
          field: "name",
          sortable: false,
        },
        {
          label: "Sektor",
          field: "departmentName",
          sortable: false,
        },
        {
          label: "Tip",
          field: "absenceReason",
          sortable: false,
        },
        {
          label: "Opis",
          field: "note",
          sortable: false,
        },
        {
          label: "Početak",
          field: "startDate",
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd.MM.yyyy",
          sortable: false,
        },
        {
          label: "Kraj",
          field: "endDate",
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd.MM.yyyy",
          sortable: false,
        },
        {
          label: "Akcije",
          field: "before",
          sortable: false,
        },
      ],
      rows: [],
    };
  },

  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
  },

  methods: {
    toggleActive() {
      console.log("toggling active!");
      console.log(this.showOnlyActive);
      this.resetUi();
      this.showOnlyActive = !this.showOnlyActive;
      if (this.showOnlyActive) {
        this.stringOnlyActive = "prikaži i neaktivna odsustva";
      } else {
        this.stringOnlyActive = "prikaži samo aktivna odsustva";
      }
      this.getDepartments();
    },

    searchFunc(row, col, cellValue, searchTerm) {
      if (typeof cellValue === "string" || cellValue instanceof String) {
        return cellValue.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (cellValue == null) {
        return true;
      }
    },

    monthChosen(mnth) {
      console.log(mnth);
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      console.log(this.selectedMonth);
      console.log(this.selectedYear);

      this.resetUi();

      this.getDepartments();
    },

    resetUi() {
      console.log("reset!!!");
      this.departmentData = [];
      this.employees = [];
      this.statuses = [];
      this.rows = [];
    },

    printPage() {
      console.log("print");
    },

    getEmployeesWithAbsenceStatusByDate() {
      ReportService.GetEmployeesWithAbsenceStatusByMonthAndYear(
        this.selectedMonth,
        this.selectedYear
      ).then((response) => {
        console.log("employees wiht absence status");
        console.log(response.data);

        let ndx = 1;

        // populate rows
        response.data.forEach((element) => {
          console.log(element);
          this.rows.push({
            ndx: ndx++,
            name: element.firstName + " " + element.lastName,
            departmentName: element.departmentName,
            absenceReason: element.absenceDescription,
            employeeId: element.employeeId,
            statusId: element.absenceStatus,
            note: element.note,
            startDate: element.startDate.split("T")[0],
            endDate: element.endDate.split("T")[0],
            employeeStatusId: element.employeeStatusId,
            isnew: false,
          });
        });

        // new button row
        this.rows.push({
          ndx: null,
          name: null,
          departmentName: null,
          absenceReason: null,
          employeeId: null,
          statusId: null,
          note: null,
          startDate: null,
          endDate: null,
          isnew: true,
        });
      });
    },
    getStatuses() {
      ReportService.GetStatuses().then((response) => {
        response.data.forEach((s) => {
          if (s.value1 !== 10) {
            this.statuses.push(s);
          }
        });
        // this.statuses = response.data;
        // console.log("this.statuses");
        // console.log(this.statuses);
        // let ndx = 1;
        console.log("rows");
        response.data.forEach((element) => {
          console.log(element);
        });

        this.getEmployeesWithAbsenceStatusByDate();
      });
    },
    editRow(abs) {
      console.log(abs);
      this.selectedAbsence = abs;
      this.$modal.show("edit-absence-modal");
    },
    deleteRow(abs) {
      console.log(abs);
      this.selectedAbsence = abs;
      this.$modal.show("delete-absence-modal");

      // this.selectedEmployee = emp;
      // this.$modal.show("delete-employee-modal");
    },
    addRow(abs) {
      console.log(abs);

      this.selectedAbsence = abs;
      this.$modal.show("add-absence-modal");

      // this.selectedEmployee = emp;
      // emp.department.id = emp.department.hiddenId;
      // emp.department.name = emp.department.hiddenName;
      // emp.department.shiftId = emp.department.hiddenShiftId;
      // this.$modal.show("add-employee-modal");
    },
    getDepartments() {
      UserService.getDepartments().then((response) => {
        // reset ui
        console.log(response.data);
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
        this.arrangeEmployees(response.data);
        this.getStatuses();
      });
    },
    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },
    arrangeEmployees(data) {
      data.forEach((element) => {
        element.employee.forEach((emp) => {
          this.employees.push({
            name: emp.firstName + " " + emp.lastName,
            id: emp.employeeId,
          });
        });
      });
    },
    addAbsence({ abs }) {
      console.log("abs");
      console.log(abs);
      this.selectedEmployee = abs;

      let empBack = new EmployeeStatusBack({
        employeId: abs.employeeId,
        statusId: abs.statusId,
        startDate: abs.startDate,
        endDate: abs.endDate,
        note: abs.note,
      });

      console.log(empBack);

      // post
      UserService.postAbsence(empBack).then(() => {
        // nađimo sve dane između
        let daylist = getDaysArray(
          new Date(this.selectedAbsence.startDate),
          new Date(this.selectedAbsence.endDate)
        );

        console.log("hic daylist");
        console.log(daylist);

        // za svaki datum ubacimo report
        daylist.forEach((day) => {
          let i = getReport01TitlePropertyFromStatusId(
            this.selectedAbsence.statusId
          );
          // let recursive = getReport01recursivePropertyFromStatusId(
          //   this.selectedAbsence.statusId
          // );
          let recursive = "N";
          let emp = this.$store.state.general.employees.find(
            (e) => e.id === abs.employeeId
          );
          let dname = getDepartmentFromEmployeeId(
            this.$store.state.general.departmentData,
            abs.employeeId
          );
          let data = {
            boldText: emp.name + " " + dname + " - ",
            note: this.selectedAbsence.note,
            // titleProperties: ,
            userReportId: 2,
            statusId: this.selectedEmployee.statusId,
            sRecursive: recursive,
            employeeId: this.selectedEmployee.employeeId,
            isConfirmed: true,
          };
          console.log("bogi");
          console.log(day);
          SpecialReportService.PostDailyReport01(data, day, i).then(
            (response) => {
              console.log(response.data);
            }
          );
        });
        this.resetUi();
        this.getDepartments();

        this.$modal.hide("add-absence-modal");
      });
    },
    addAbsenceAndContinue() {},
    async editAbsence({ abs, oldStartDate, oldEndDate /*, oldStatusId*/ }) {
      console.log("Edit absence...", abs);
      console.log("Old start date...", oldStartDate);
      console.log("Old End date...", oldEndDate);

      // Prvo izbrišemo stare podatke
      const deleteAbsenceResponse = await UserService.deleteAbsence({
        employeeStatusId: abs.employeeStatusId,
      });

      console.log("delete absence response: ", deleteAbsenceResponse);

      // // EDIT: ReportComment se već briše u deleteAbsence metodi
      // // Zatim izbrišemo i njegove report comment-e
      // // nađimo sve dane između
      // let daylist = getDaysArray(
      //   getFromDateOnlyDatePart(new Date(oldStartDate)),
      //   getFromDateOnlyDatePart(new Date(oldEndDate))
      // );
      // console.log(daylist);

      // // Delete all the corresponding ReportComments
      // for (let index = 0; index < daylist.length; index++) {
      //   const day = daylist[index];
      //   const deleteReportResponse =
      //     await SpecialReportService.DeleteReport01ByValue1TitlePropertiesAndReportDate(
      //       abs.employeeId,
      //       getReport01TitlePropertyFromStatusId(oldStatusId),
      //       day
      //     );

      //   console.log("deleteReport response: ", deleteReportResponse);
      // }

      // Add new one!
      this.addAbsence({ abs });

      this.$modal.hide("edit-absence-modal");
    },
    deleteAbsence() {
      console.log("hic!!!");
      console.log(this.selectedAbsence);
      console.log(this.selectedEmployee);
      UserService.deleteAbsence({
        employeeStatusId: this.selectedAbsence.employeeStatusId,
      }).then(() => {
        // // nađimo sve dane između
        // let daylist = getDaysArray(
        //   getFromDateOnlyDatePart(new Date(this.selectedAbsence.startDate)),
        //   getFromDateOnlyDatePart(new Date(this.selectedAbsence.endDate))
        // );
        // console.log("daylist deleteReport");
        // console.log(daylist);

        // // za svaki datum izbrišimo reportcomment
        // daylist.forEach((day) => {
        //   console.log("gogo2");
        //   console.log(day);
        //   SpecialReportService.DeleteReport01ByValue1TitlePropertiesAndReportDate(
        //     this.selectedEmployee.employeeId,
        //     getReport01TitlePropertyFromStatusId(
        //       this.selectedEmployee.statusId
        //     ),
        //     day
        //   ).then((response) => {
        //     console.log(response.data);
        //   });
        // });

        this.resetUi();

        this.getDepartments();
      });
      this.$modal.hide("delete-absence-modal");
    },
  },
};
</script>

<style scoped>
/* Component-specific styles */
.page-header-inline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px 24px;
  border-radius: var(--ev-radius-lg);
  color: white;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-left .ev-page-title {
  margin: 0;
  font-size: 1.5rem;
}

.header-subtitle {
  color: rgba(20, 20, 20, 0.85);
  font-size: 0.9rem;
  padding-left: 16px;
  border-left: 1px solid rgba(20, 20, 20, 0.3);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-right .ev-filter-label {
  color: rgba(20, 20, 20, 0.85);
  margin-bottom: 0;
}

.header-actions {
  display: flex;
  align-items: center;
}

.toggle-link {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.15);
  transition: all 0.2s ease;
}

.toggle-link:hover {
  background: rgba(255, 255, 255, 0.25);
  color: white;
}
</style>
